import { selectAll } from "../utils/utils";
import Swiper from "swiper/bundle";

export class CardsReviews {
  constructor(el) {
    if (el) {
      this.init(el);
    }
  }

  init(el) {
    this.el = el;
    this.props();
    this.render();
  }

  props() {
    this.cardsReviewsContainer = selectAll("[data-cards-reviews]");
    this.cardsReviewsVideos = selectAll("video");
  }

  render() {
    this.cardsReviewsCarousel();
    this.cardsReviewsVideosHandler();
  }

  cardsReviewsCarousel = () => {
    for (var i = 0; i < this.cardsReviewsContainer.length; i++) {
      new Swiper(this.cardsReviewsContainer[i], {
        slidesPerView: 1,
        spaceBetween: 15,
        slidesOffsetBefore: 24,
        a11y: false,
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 2.5,
            spaceBetween: 15,
            slidesOffsetBefore: 80,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          },
          1180: {
            slidesPerView: 3.5,
            spaceBetween: 15,
            slidesOffsetBefore: 80,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          },
        },
      });
    }
  };

  cardsReviewsVideosHandler = () => {
    this.cardsReviewsVideos.forEach((video) => {
      const controls = video.parentElement.querySelector(
        ".video-controls-overlay"
      );
      controls.addEventListener("click", (e) => {
        if (video.paused) {
          video.play();
          e.currentTarget.classList.add("playing");
        } else {
          video.pause();
          e.currentTarget.classList.remove("playing");
        }
      });
    });
  };
}
